// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets de la disposición del tragamonedas
 * @param {*} scene
 */
export function cargaAssetsDisposicion(scene) {
  scene.load.image(
    'disposicion1',
    ROUTES.rutaBlackJackDisposicion + '/disposicion02Fase1Resized.png'
  );

  scene.load.image(
    'disposicion2',
    ROUTES.rutaBlackJackDisposicion + '/disposicion02Fase2Resized.png'
  );

  scene.load.image(
    'disposicion3',
    ROUTES.rutaBlackJackDisposicion + '/disposicion02PreFase2Resized.png'
  );

  scene.load.image(
    'disposicion4',
    ROUTES.rutaBlackJackDisposicion + '/disposicion04Fase1Resized.png'
  );

  scene.load.image(
    'disposicion5',
    ROUTES.rutaBlackJackDisposicion + '/disposicion04Fase2Resized.png'
  );
}
